module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-left-a4260c4e4834a22d2dda570e213ae9bc.svg";